import { GET_ALL_CUSTOMERS_SUCCESS, GET_ALL_CUSTOMERS_FAIL, LOGOUT, GET_ALL_CUSTOMERS_REQUEST } from "./types";

import customerService from "../services/customerService";
export const getAllCustomers = () => async (dispatch) => {
  dispatch({ type: GET_ALL_CUSTOMERS_REQUEST });
  try {
    const res = await customerService.getAllCustomers();
    dispatch({
      type: GET_ALL_CUSTOMERS_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: GET_ALL_CUSTOMERS_FAIL,
      payload: err.response.data.error,
    });
  }
};